import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { CompanyDataAnalysisOptions, analyticsSortList, defaultChartOrTableHeight } from './CompanyDataAnalysisService';
import { Symbols } from '@/symbols';
import { CompanyDataAnalysisViewType } from './CompanyDataAnalysis.type';
import _ from 'lodash';
import { CompanyDataAnalysisDataSet, CompanyDataAnalysisEventKey, CompanyDataAnalysisKeyType } from '@/apis/service/company/CompanyDataAnalysisApi.type';
import { searchColor } from './echartsOption';
export const UV_ANALYSIS = 'uvAnalysis';
export const PV_ANALYSIS = 'pvAnalysis';
let CompanyAnalyticsDataAnalysisService = class CompanyAnalyticsDataAnalysisService {
    constructor(companyDataAnalysisService, companyDataAnalysisApi, i18n) {
        this.companyDataAnalysisService = companyDataAnalysisService;
        this.companyDataAnalysisApi = companyDataAnalysisApi;
        this.i18n = i18n;
        /**
         * 搜索次数
         */
        this.instancesPvOption = new CompanyDataAnalysisOptions();
        this.instancesUvOption = new CompanyDataAnalysisOptions();
        /*
         * 自定义分析
         */
        this.customAnalysisOption = new CompanyDataAnalysisOptions();
        /*
         * Alert Usage
         */
        this.alertUsageOption = new CompanyDataAnalysisOptions();
        /*
         * Alert Email
         */
        this.alertEmailOption = new CompanyDataAnalysisOptions();
        // 新增用户配置
        this.newUserPermissionOption = new CompanyDataAnalysisOptions();
        /**
         * 新用户获取权限 Detail 配置
         */
        this.newUserPermissionDetailOption = new CompanyDataAnalysisOptions();
        this.pVConfigInit();
        this.uVConfigInit();
        this.customAnalysisConfigInit();
        this.alertUsageConfigInit();
        this.alertEmailConfigInit();
        this.newUserPermissionConfigInit();
        this.newUserPermissionDetailConfigInit();
    }
    pVConfigInit() {
        this.instancesPvOption.reportName = CompanyDataAnalysisKeyType.ANALYTICS_SEARCH;
        this.instancesPvOption.title = this.i18n.t('backoffice.company.dataAnalysis.analyticsPv');
        this.instancesPvOption.viewType = CompanyDataAnalysisViewType.Chart;
        this.instancesPvOption.canChangeViewType = true;
        this.instancesPvOption.canCollapse = false;
        this.instancesPvOption.statistics = [];
        this.instancesPvOption.tableOptions.columns = this.companyDataAnalysisService.getAnalyticsSearchTableColumns();
        this.instancesPvOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.instancesPvOption.chartId = PV_ANALYSIS;
        this.instancesPvOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    uVConfigInit() {
        this.instancesUvOption.reportName = CompanyDataAnalysisKeyType.ANALYTICS_SEARCH;
        this.instancesUvOption.title = this.i18n.t('backoffice.company.dataAnalysis.analyticsUv');
        this.instancesUvOption.viewType = CompanyDataAnalysisViewType.Chart;
        this.instancesUvOption.canChangeViewType = true;
        this.instancesUvOption.canCollapse = false;
        this.instancesUvOption.statistics = [];
        this.instancesUvOption.tableOptions.columns = this.companyDataAnalysisService.getAnalyticsSearchTableColumns();
        this.instancesUvOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.instancesUvOption.chartId = UV_ANALYSIS;
        this.instancesUvOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getPvUvData(params) {
        this.instancesPvOption.loading = true;
        this.instancesUvOption.loading = true;
        const pvParams = _.cloneDeep(params);
        pvParams.report_name = this.instancesPvOption.reportName;
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(pvParams).then((data) => {
            this.instancesPvOption.Updated = data.data_date;
            this.instancesUvOption.Updated = data.data_date;
            this.instancesPvOption.noData = data.data_detail.length === 0;
            this.instancesUvOption.noData = data.data_detail.length === 0;
            if (this.instancesPvOption.noData)
                return;
            const params = {
                data,
                dataSet: CompanyDataAnalysisDataSet.TOTAL_COUNT,
                sortList: analyticsSortList,
                colorList: searchColor,
                columns: this.companyDataAnalysisService.getAnalyticsSearchTableColumns(),
            };
            this.instancesPvOption.chartOption = this.companyDataAnalysisService.getStackBarCharOption(params);
            this.instancesPvOption.tableOptions.rows = this.companyDataAnalysisService.getAnalysisTableRows(data.data_detail, CompanyDataAnalysisDataSet.TOTAL_COUNT);
            params.dataSet = CompanyDataAnalysisDataSet.USER_COUNT;
            this.instancesUvOption.chartOption = this.companyDataAnalysisService.getStackBarCharOption(params);
            this.instancesUvOption.tableOptions.rows = this.companyDataAnalysisService.getAnalysisTableRows(data.data_detail, CompanyDataAnalysisDataSet.USER_COUNT);
        }).catch(() => {
            this.instancesPvOption.noData = true;
            this.instancesUvOption.noData = true;
        }).finally(() => {
            this.instancesPvOption.loading = false;
            this.instancesUvOption.loading = false;
        });
    }
    customAnalysisConfigInit() {
        this.customAnalysisOption.reportName = CompanyDataAnalysisKeyType.ANALYTICS_CUSTOM_ANALYSIS;
        this.customAnalysisOption.title = this.i18n.t('backoffice.company.dataAnalysis.customAnalysis');
        this.customAnalysisOption.canCollapse = true;
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            total_count: this.i18n.t('backoffice.company.dataAnalysis.commonPv'),
            user_count: this.i18n.t('backoffice.company.dataAnalysis.commonUv'),
        };
        this.customAnalysisOption.tableOptions.columns = this.companyDataAnalysisService.getPvUvTableColumns(labels);
        this.customAnalysisOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.customAnalysisOption.chartId = 'customAnalysis';
        this.customAnalysisOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getCustomAnalysisData(params) {
        this.customAnalysisOption.loading = true;
        const concurrencyParams = _.cloneDeep(params);
        concurrencyParams.report_name = this.customAnalysisOption.reportName;
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(concurrencyParams).then(data => {
            this.customAnalysisOption.Updated = data.data_date;
            this.customAnalysisOption.noData = data.data_detail.length === 0;
            const statistics = {
                total_count: data.total_count,
                user_count: data.user_count,
                key: 'common',
            };
            this.customAnalysisOption.statistics = this.companyDataAnalysisService.getPvUvStatistics(statistics);
            this.customAnalysisOption.tableOptions.rows = this.companyDataAnalysisService.getPvUvTableRows(data.data_detail, CompanyDataAnalysisEventKey.CUSTOM_ANALYSIS);
            const optionParams = {
                data: data.data_detail,
                total_count: this.customAnalysisOption.statistics[0].label,
                user_count: this.customAnalysisOption.statistics[1].label,
                key: CompanyDataAnalysisEventKey.CUSTOM_ANALYSIS,
            };
            this.customAnalysisOption.chartOption = this.companyDataAnalysisService.getPvUvBarChartOption(optionParams);
        }).catch(() => {
            this.customAnalysisOption.noData = true;
        }).finally(() => {
            this.customAnalysisOption.loading = false;
        });
    }
    alertUsageConfigInit() {
        this.alertUsageOption.reportName = CompanyDataAnalysisKeyType.ANALYTICS_EMAIL_ALERT;
        this.alertUsageOption.title = this.i18n.t('backoffice.company.dataAnalysis.alertUsage');
        this.alertUsageOption.canCollapse = false;
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            total_count: this.i18n.t('backoffice.company.dataAnalysis.commonPv'),
            user_count: this.i18n.t('backoffice.company.dataAnalysis.commonUv'),
        };
        this.alertUsageOption.tableOptions.columns = this.companyDataAnalysisService.getPvUvTableColumns(labels);
        this.alertUsageOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.alertUsageOption.chartId = 'alertUsage';
        this.alertUsageOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getAlertUsageData(params) {
        this.alertUsageOption.loading = true;
        const concurrencyParams = _.cloneDeep(params);
        concurrencyParams.report_name = this.alertUsageOption.reportName;
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(concurrencyParams).then(data => {
            this.alertUsageOption.Updated = data.data_date;
            this.alertUsageOption.noData = data.data_detail.length === 0;
            const statistics = {
                total_count: data.total_count,
                user_count: data.user_count,
                key: 'common',
            };
            this.alertUsageOption.statistics = this.companyDataAnalysisService.getPvUvStatistics(statistics);
            this.alertUsageOption.tableOptions.rows = this.companyDataAnalysisService.getPvUvTableRows(data.data_detail, CompanyDataAnalysisEventKey.EMAIL_ALERT);
            const optionParams = {
                data: data.data_detail,
                total_count: this.alertUsageOption.statistics[0].label,
                user_count: this.alertUsageOption.statistics[1].label,
                key: CompanyDataAnalysisEventKey.EMAIL_ALERT,
            };
            this.alertUsageOption.chartOption = this.companyDataAnalysisService.getPvUvBarChartOption(optionParams);
        }).catch(() => {
            this.alertUsageOption.noData = true;
        }).finally(() => {
            this.alertUsageOption.loading = false;
        });
    }
    alertEmailConfigInit() {
        this.alertEmailOption.reportName = CompanyDataAnalysisKeyType.ANALYTICS_EMAIL_ALERT_STATUS;
        this.alertEmailOption.title = this.i18n.t('backoffice.company.dataAnalysis.email');
        this.alertEmailOption.canCollapse = false;
        this.alertEmailOption.chartDescription = true;
        this.alertEmailOption.tableOptions.columns = this.companyDataAnalysisService.getAnalyticsEmailTableColumns();
        this.alertEmailOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.alertEmailOption.chartId = 'alertEmail';
        this.alertEmailOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
        this.alertEmailOption.chartDescriptionList = [
            {
                title: this.i18n.t('backoffice.company.dataAnalysis.recipients'),
                content: this.i18n.te('backoffice.company.dataAnalysis.recipientsTip') ? this.i18n.t('backoffice.company.dataAnalysis.recipientsTip') : '',
            },
            {
                title: this.i18n.t('backoffice.company.dataAnalysis.read'),
                content: this.i18n.te('backoffice.company.dataAnalysis.readTip') ? this.i18n.t('backoffice.company.dataAnalysis.readTip') : '',
            },
            {
                title: this.i18n.t('backoffice.company.dataAnalysis.clicked'),
                content: this.i18n.te('backoffice.company.dataAnalysis.clickedTip') ? this.i18n.t('backoffice.company.dataAnalysis.clickedTip') : '',
            },
            {
                title: this.i18n.t('backoffice.company.dataAnalysis.readRatio'),
                content: this.i18n.t('backoffice.company.dataAnalysis.readRatioTip'),
            },
            {
                title: this.i18n.t('backoffice.company.dataAnalysis.clickedRatio'),
                content: this.i18n.t('backoffice.company.dataAnalysis.clickedRatioTip'),
            }
        ];
    }
    getAlertEmailData(params) {
        this.alertEmailOption.loading = true;
        const concurrencyParams = _.cloneDeep(params);
        concurrencyParams.report_name = this.alertEmailOption.reportName;
        return this.companyDataAnalysisApi.getCompanyAnalyticsEmailData(concurrencyParams).then(data => {
            this.alertEmailOption.Updated = data.data_date;
            this.alertEmailOption.noData = data.data_detail.length === 0;
            const statistics = {
                Recipients: data.send_count,
                Read: data.open_count,
                Clicked: data.click_count,
            };
            this.alertEmailOption.statistics = this.companyDataAnalysisService.getAlertEmailStatistics(statistics);
            this.alertEmailOption.tableOptions.rows = this.companyDataAnalysisService.getAnalysisEmailTableRow(data.data_detail);
            this.alertEmailOption.chartOption = this.companyDataAnalysisService.getLineBarChartOption(data);
        }).catch(() => {
            this.alertEmailOption.noData = true;
        }).finally(() => {
            this.alertEmailOption.loading = false;
        });
    }
    newUserPermissionConfigInit() {
        this.newUserPermissionOption.reportName = CompanyDataAnalysisKeyType.ANALYTICS_NEW_USER;
        this.newUserPermissionOption.title = this.i18n.t('backoffice.company.dataAnalysis.overview');
        this.newUserPermissionOption.canCollapse = false;
        this.newUserPermissionOption.tips = [];
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            user_count: this.i18n.t('backoffice.company.dataAnalysis.NewUserPermission'),
        };
        this.newUserPermissionOption.tableOptions.columns = this.companyDataAnalysisService.getPvUvTableColumns(labels);
        this.newUserPermissionOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.newUserPermissionOption.statistics = [];
        this.newUserPermissionOption.chartId = 'newAnalyticsUserPermissionChart';
        this.newUserPermissionOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getNewUserPermissionData(params) {
        this.newUserPermissionOption.loading = true;
        const newUserPermissionParams = { ...params, report_name: this.newUserPermissionOption.reportName };
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(newUserPermissionParams).then(data => {
            this.newUserPermissionOption.Updated = data.data_date;
            this.newUserPermissionDetailOption.Updated = data.data_date;
            this.newUserPermissionOption.noData = data.data_detail.length === 0;
            this.newUserPermissionOption.tableOptions.rows = this.companyDataAnalysisService.getPvUvTableRows(data.data_detail, CompanyDataAnalysisEventKey.ANALYTICS);
            const optionParams = {
                data: data.data_detail,
                user_count: this.i18n.t('backoffice.company.dataAnalysis.NewUserPermission'),
                key: CompanyDataAnalysisEventKey.ANALYTICS,
            };
            this.newUserPermissionOption.chartOption = this.companyDataAnalysisService.getPvUvBarChartOption(optionParams);
        }).catch(() => {
            this.newUserPermissionOption.noData = true;
        }).finally(() => {
            this.newUserPermissionOption.loading = false;
        });
    }
    newUserPermissionDetailConfigInit() {
        this.newUserPermissionDetailOption.reportName = CompanyDataAnalysisKeyType.ANALYTICS_NEW_USER;
        this.newUserPermissionDetailOption.title = this.i18n.t('backoffice.company.dataAnalysis.userDetails');
        this.newUserPermissionDetailOption.tips = [
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.analyticsLoginCount'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.analyticsLoginCountTips'),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.analyticsLoginTotalCount'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.analyticsLoginTotalCountTips'),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.joinDate'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.joinDateTips'),
            }
        ];
        this.newUserPermissionDetailOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.newUserPermissionDetailOption.tableOptions.paginationOptions.enabled = true;
        this.newUserPermissionDetailOption.tableOptions.paginationOptions.perPageDropdownEnabled = false;
        this.newUserPermissionDetailOption.canChangeViewType = false;
        this.newUserPermissionDetailOption.viewType = CompanyDataAnalysisViewType.Table;
        this.newUserPermissionDetailOption.canCollapse = false;
        this.newUserPermissionDetailOption.tableFields = this.companyDataAnalysisService.getUserTableColumns(CompanyDataAnalysisEventKey.ANALYTICS);
        this.newUserPermissionDetailOption.tableOptions.columns = this.newUserPermissionDetailOption.tableFields;
    }
    async getNewUserPermissionDetailsData(params) {
        let newUserPermissionDetailParams = _.cloneDeep(params);
        this.newUserPermissionDetailOption.loading = true;
        newUserPermissionDetailParams = this.companyDataAnalysisService.getDetailTableDefaultParams(params, this.newUserPermissionDetailOption.reportName);
        // 先获取字段设置
        this.newUserPermissionDetailOption.tableOptions.columns = await this.companyDataAnalysisService.getFiledSettingColumns(this.newUserPermissionOption.reportName, this.newUserPermissionDetailOption.tableFields);
        return this.companyDataAnalysisApi.getCompanyDataAnalysisUserPrivileges(newUserPermissionDetailParams).then(data => {
            this.newUserPermissionDetailOption.noData = data.iTotalRecords === 0;
            this.newUserPermissionDetailOption.tableOptions.paginationOptions.setCurrentPage = Number(data.s_echo);
            this.newUserPermissionDetailOption.tableOptions.totalRecords = data.iTotalRecords;
            this.newUserPermissionDetailOption.tableOptions.totalRows = data.iTotalDisplayRecords;
            this.newUserPermissionDetailOption.tableOptions.rows = this.companyDataAnalysisService.getUserTableRows(data.aaData, CompanyDataAnalysisEventKey.ANALYTICS);
        }).catch(() => {
            this.newUserPermissionDetailOption.noData = true;
        }).finally(() => {
            this.newUserPermissionDetailOption.loading = false;
        });
    }
    initData(params) {
        Promise.all([
            this.getPvUvData(params),
            this.getCustomAnalysisData(params),
            this.getAlertUsageData(params),
            this.getAlertEmailData(params),
            this.getNewUserPermissionData(params),
            this.getNewUserPermissionDetailsData(params)
        ]);
    }
};
CompanyAnalyticsDataAnalysisService = __decorate([
    injectable(),
    __param(0, inject(Symbols.CompanyDataAnalysisService)),
    __param(1, inject(Symbols.CompanyDataAnalysisApi)),
    __param(2, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object, Object, Object])
], CompanyAnalyticsDataAnalysisService);
export { CompanyAnalyticsDataAnalysisService };
